<template>
  <div>
    <div class="d-flex mb-2 w-100" id="style-2" style="overflow: auto;">
      <div
        style="cursor: pointer"
        class="call-status-box"
        :style="`border-top: 6px solid #${STATUS_INDEX_COLOR[0]}`"
        :class="isActive == 'all' ? 'active' : ''"
        @click="clickFilterModule('all')"
      >
        <div style="font-weight: bold; margin-right: 4px; color: #4E4E4E; white-space: nowrap;">
          Tất cả
        </div>
        <div class="call-status-count" :style="`background: #${STATUS_INDEX_COLOR[0]}`">
          {{totalDuoCareModule}}
        </div>
      </div>
      <v-menu
        open-on-hover
        bottom
        offset-y
        v-for="(module, index) in dataCallStatus"
        :key="'status-box'+index"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
            class="call-status-box"
            :class="isActive == module.id ? 'active' : ''"
            :style="`border-top: 6px solid #${STATUS_INDEX_COLOR[index + 1]}`"
            @click="clickFilterModule(module)"
          >
            <div style="font-weight: bold; margin-right: 4px; color: #4E4E4E; white-space: nowrap">
              {{module.name}}
            </div>
            <div class="call-status-count" :style="`background: #${STATUS_INDEX_COLOR[index + 1]}`">
              {{module.no}}
            </div>
          </div>
        </template>
        <v-list>
          <v-list-item
            dense
            v-for="(item, index) in module.data"
            :key="index"
            class="item-call-status"
            :style="`border-left: 3px solid ${item.color}`"
            @click="clickFilterModule(item)"
            :class="isActiveItem == `${item.typeId}_${item.id}` ? 'active' : ''"
          >
            <v-list-item-title class="d-flex align-center">
              {{item.name}}
              <div class="call-status-count ml-2">
                {{item.no}}
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
<!--    <v-simple-table-->
<!--      class="table-layout table-contact table-filter-contact"-->
<!--      id="style-2"-->
<!--    >-->
<!--      <template v-slot:default>-->
<!--        <thead>-->
<!--        <tr>-->
<!--          <th-->
<!--            class="font-weight-regular &#45;&#45;module-title"-->
<!--            style="height: 0px !important;"-->
<!--            rowspan="2"-->
<!--            @click="clickFilterModule('all')"-->
<!--            :class="isActive == 'all' ? 'active' : ''"-->
<!--          >Tất cả</th>-->
<!--          <template v-for="(module, index) in typeHeaderStatusModule">-->
<!--            <th-->
<!--              :rowspan="module.code ? 2 : null"-->
<!--              class="font-weight-regular &#45;&#45;module-title"-->
<!--              style="text-align: center; height: 0px !important;"-->
<!--              :key="'type-' + index"-->
<!--              :colspan="module.colspan"-->
<!--            >-->
<!--              {{ module.name }}-->
<!--            </th>-->
<!--          </template>-->
<!--        </tr>-->
<!--        <tr class="tr-contact-status">-->
<!--          <template v-for="(itemModule, index) in countStatusModuleList">-->
<!--            <th-->
<!--              style="height: 0px !important;"-->
<!--              @click="clickFilterModule(itemModule)"-->
<!--              class="font-weight-regular call-status"-->
<!--              :style="`background-color: ${itemModule.color}`"-->
<!--              :key="'name-type-' + index"-->
<!--              :class="isActive == `${itemModule.typeId}_${itemModule.id}` ? 'active' : ''"-->
<!--              v-if="!colsNotIn.includes(itemModule.code)"-->
<!--            >-->
<!--              {{ itemModule.name }}-->
<!--            </th>-->
<!--          </template>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--        <tr>-->
<!--          <td style="min-width: 5rem; height: 0px !important;" :class="isActive == 'all' ? 'active total-number' : 'total-number'">{{ totalDuoCareModule }}</td>-->
<!--          <td-->
<!--            v-for="(itemModule, index) in countStatusModuleList"-->
<!--            :key="'noContactModule-' + index"-->
<!--            class="count-number-status"-->
<!--            style="height: 0px !important;"-->
<!--            :class="isActive == `${itemModule.typeId}_${itemModule.id}` ? 'active' : ''"-->
<!--          >-->
<!--            {{itemModule.noContact}}-->
<!--          </td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </template>-->
<!--    </v-simple-table>-->
  </div>
</template>
<script>
import { STATUS_INDEX_COLOR } from '@/modules/duo_care/constant';

export default {
  props: {
    dataCallStatus: {
      type: Array,
      default: () => [],
    },
    filterForm: {
      type: Object,
      default: () => ({}),
    },
    totalDuoCareModule: {
      type: Number,
      default: 0,
    },
    typeHeaderStatusModule: {
      type: Array,
      default: () => [],
    },
    countStatusModuleList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      STATUS_INDEX_COLOR,
      isActive: 'all',
      isActiveItem: null,
      colsNotIn: ['SL', 'SP', 'SĐL'],
    };
  },
  methods: {
    async clickFilterModule(item) {
      if (item.data) {
        const callStatusIds = [];
        item.data.forEach((e) => {
          callStatusIds.push(e.id);
        });
        this.filterForm.callIds = item.id;
        this.filterForm.callStatusIds = callStatusIds;
        this.filterForm.page = 1;
        this.filterForm.pendingPage = 1;
        Bus.$emit('duo-care-list-no-count-filter');
        this.isActive = `${item.id}`;
        this.isActiveItem = null;
        return;
      }
      if (!item.id && !item.typeId && item !== 'all') return;
      if (item === 'all') {
        this.filterForm.callIds = [];
        this.filterForm.callStatusIds = [];
        this.filterForm.page = 1;
        this.filterForm.pendingPage = 1;
        Bus.$emit('duo-care-list-no-count-filter');
        this.isActive = 'all';
      } else {
        this.filterForm.callIds = [item.typeId];
        this.filterForm.callStatusIds = item.id ? [item.id] : [];
        this.filterForm.page = 1;
        this.filterForm.pendingPage = 1;
        Bus.$emit('duo-care-list-no-count-filter');
        this.isActive = `${item.typeId}`;
        this.isActiveItem = `${item.typeId}_${item.id}`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.table-contact{
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  .call-status{
    text-align: center !important;
    font-style: normal;
    font-weight: 500 !important;
    font-size: 12px;
    line-height: 16px;
    color: #FFFFFF !important;
  }
  .count-number-status{
    text-align: center !important;
    font-style: normal;
    font-weight: 500 !important;
    font-size: 12px;
    line-height: 16px;
    color: #333333 !important;
  }
}
.active {
  font-weight: bold!important;
  font-size: 14px!important;
  font-weight: bold;
}
.font-weight-regular {
  border-bottom: thin solid rgba(0, 0, 0, 0.12); cursor: pointer
}
.--module-title {
  font-weight: bold !important;
  font-size: 14px !important;
}
.total-number {
  color: #411BAE;
}
.table-filter-contact {
  th {
    border-right: 1px solid #d2d2d2;
    height: 30px;
    &:last-child {
      border-right: thin solid rgba(0, 0, 0, 0.12);
    }
  }
  td {
    padding-top: 0;
    padding-bottom: 0;
    height: 30px;
    border: 1px solid #d2d2d2;
  }
  thead tr {
    height: 30px;
    th {
      color: #000000;
      min-width: 65px !important;
    }
  }
  tbody {
    tr {
      height: 30px;
      td {
        position: relative;
        border: 1px solid #d2d2d2;
        &:last-child {
          border-right: 0;
        }
      }
    }
  }
}
.call-status-box {
  opacity: 0.5;
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border-top: 6px solid #739A77;
  border-radius: 4px 4px 0 0;
  padding: 4px 16px;
  transition: all .2s ease-in-out;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}
.call-status-box.active {
  opacity: 1;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}
.call-status-box:not(:last-child) {
  margin-right: 16px;
}
.call-status-count {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 70%;
  background: #828282;
  color: white;
  height: 25px;
  width: 40px;
  font-weight: bold;
  margin-left: 4px;
}
.item-call-status {
  padding: 0 8px;
}
.item-call-status.v-list-item--link:before {
  background: white;
}
.item-call-status .v-list-item__title {
  padding: 6px 8px;
  border-radius: 12px;
  transition: all .2s ease-in-out;
}
.item-call-status.active .v-list-item__title {
  background: #F0EDED;
}
.item-call-status:not(:last-child) {
  margin-bottom: 6px;
}
.item-call-status:hover .v-list-item__title{
  background: #F0EDED;
}
</style>
